/**
 * @file   : AInputTime.js
 * @author :  ()
 * @date   : 6/5/2019, 4:16:28 PM
 */
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { SELECT } from '../../utilities/FormHelperUtils'
import { isEmpty, isUndefined } from '../../utilities/GeneralUtils'
import Cont from '../layout/Cont'
import AInput from './AInput'
import AInputLabel from './AInputLabel'

class AInputTime extends Component {
  constructor(props) {
    super(props)
    this.currHourValue = AInputTime.getHourValue(
      props.value,
      props.use24HourFormat,
    )
    this.currMinValue = AInputTime.getMinuteValue(props.value)
    this.currAMPM = AInputTime.getAMPMVlaue(props.value)
    this.state = { value: props.value }
  }

  componentDidUpdate(prevProps) {
    const { value, use24HourFormat } = this.props

    if (value !== prevProps.value && !isUndefined(value)) {
      this.currHourValue = AInputTime.getHourValue(value, use24HourFormat)
      this.currMinValue = AInputTime.getMinuteValue(value)
      this.currAMPM = AInputTime.getAMPMVlaue(value)

      this.setState({
        value,
      })
    }
  }

  // ****************static methods********************************
  static addHourZeroIfRequired(hour) {
    if (hour.length < 2 && parseInt(hour) < 10) {
      return `0${hour}`
    }

    return hour
  }

  static getOption(key, value, content) {
    return (
      <option key={key} value={value}>
        {content}
      </option>
    )
  }

  static getHourValue(value, use24HourFormat) {
    if (isEmpty(value)) {
      return null
    }

    const timeArray = value.split(':')
    const hour = timeArray[0]

    if (use24HourFormat) {
      return hour
    }
    const hour12Value = parseInt(hour) % 12 || 12

    const hour12Format =
      hour12Value < 10 && use24HourFormat
        ? `0${hour12Value.toString()}`
        : hour12Value.toString()

    return hour12Format
  }

  static getMinuteValue(value) {
    if (isEmpty(value)) {
      return null
    }

    const timeArray = value.split(':')
    const minute = timeArray[1]

    return minute
  }

  static getAMPMVlaue(value) {
    if (isEmpty(value)) {
      return 'am'
    }

    const hour = AInputTime.getHourValue(value, true)
    if (parseInt(hour) >= 12) {
      return 'pm'
    }

    return 'am'
  }

  static getTimeLiteral(hourValue, minValue, ampm, use24HourFormat) {
    let timeLiteral = null
    let literalHourValue = hourValue

    if (!isEmpty(hourValue) && !isEmpty(minValue)) {
      if (!use24HourFormat) {
        if (ampm === 'pm') {
          if (literalHourValue !== '12') {
            literalHourValue = (parseInt(hourValue) + 12).toString()
          }
        } else if (literalHourValue === '12') {
          literalHourValue = '0'
        }
      }
      timeLiteral = `${AInputTime.addHourZeroIfRequired(
        literalHourValue,
      )}:${minValue}`
    }

    return timeLiteral
  }

  // ****************onChange********************************
  handleChange(inputvalue, inputType = 'hh') {
    const { use24HourFormat, onChange } = this.props

    if (!isEmpty(inputType)) {
      if (isEmpty(inputvalue)) {
        this.currHourValue = null
        this.currMinValue = null
      } else if (inputType === 'hh') {
        this.currHourValue = inputvalue
        if (isEmpty(this.currMinValue)) {
          this.currMinValue = '00'
        }
      } else if (inputType === 'mm') {
        this.currMinValue = inputvalue
        if (isEmpty(this.currHourValue)) {
          if (use24HourFormat) {
            this.currHourValue = '00'
          } else {
            this.currHourValue = '12'
          }
        }
      } else if (inputType === 'ampm') {
        this.currAMPM = inputvalue
      }
      const newValue = AInputTime.getTimeLiteral(
        this.currHourValue,
        this.currMinValue,
        this.currAMPM,
        use24HourFormat,
      )
      this.setState({
        ...this.state,
        value: newValue,
      })

      onChange(newValue)
    }
  }

  // ****************UI methods********************************
  getHourUI() {
    const { id, cmpRef, use24HourFormat, hourLabel, cmpLabelHour } = this.props
    const { value } = this.state
    const optionsList = []
    const maxHours = use24HourFormat ? 24 : 12
    const hourValue = AInputTime.getHourValue(value, use24HourFormat)

    let initCtr = 0
    optionsList.push(AInputTime.getOption(0, '', hourLabel))
    initCtr += 1

    for (let i = 0; i < maxHours; i++) {
      let formattedHour = null
      if (use24HourFormat) {
        if (i < 10) {
          formattedHour = `0${i.toString()}`
        } else {
          formattedHour = i.toString()
        }
      } else {
        formattedHour = (i + initCtr).toString()
      }
      optionsList.push(
        AInputTime.getOption(i + 1, formattedHour, formattedHour),
      )
    }

    return (
      <AInput
        id={`${id}-hour`}
        cmpRef={`${cmpRef}-hour`}
        cmpLabel={cmpLabelHour}
        onChange={(evt) => {
          this.handleChange(evt.target.value, 'hh')
        }}
        type={SELECT}
        value={isEmpty(hourValue) ? '' : hourValue}
      >
        {optionsList}
      </AInput>
    )
  }

  getMinutesUI() {
    const { id, cmpRef, minuteLabel, cmpLabelMin } = this.props
    const { value } = this.state
    const optionsList = []
    const maxMinutes = 60
    const minuteValue = AInputTime.getMinuteValue(value)

    let initCtr = 0
    optionsList.push(AInputTime.getOption(0, '', minuteLabel))
    initCtr += 1

    for (let i = 0; i < maxMinutes; i++) {
      let formattedMinute = i.toString()
      if (i < 10) {
        formattedMinute = `0${i.toString()}`
      }
      optionsList.push(
        AInputTime.getOption(i + initCtr, formattedMinute, formattedMinute),
      )
    }

    return (
      <AInput
        id={`${id}-minute`}
        cmpRef={`${cmpRef}-minute`}
        cmpLabel={cmpLabelMin}
        onChange={(evt) => {
          this.handleChange(evt.target.value, 'mm')
        }}
        type={SELECT}
        value={isEmpty(minuteValue) ? '' : minuteValue}
      >
        {optionsList}
      </AInput>
    )
  }

  getAMPMUI() {
    const { id, cmpRef, use24HourFormat, amLabel, pmLabel, cmpLabelAMPM } =
      this.props
    const { value } = this.state
    const optionsList = []
    if (use24HourFormat) {
      return null
    }

    optionsList.push(AInputTime.getOption(0, 'am', amLabel))
    optionsList.push(AInputTime.getOption(1, 'pm', pmLabel))

    return (
      <AInput
        id={`${id}-ampm`}
        cmpRef={`${cmpRef}-ampm`}
        cmpLabel={cmpLabelAMPM}
        onChange={(evt) => {
          this.handleChange(evt.target.value, 'ampm')
        }}
        type={SELECT}
        value={AInputTime.getAMPMVlaue(value)}
      >
        {optionsList}
      </AInput>
    )
  }

  getHelpContent() {
    const { help } = this.props
    let helpContent = null
    if (!isUndefined(help) && !isEmpty(help)) {
      helpContent = <span className={'help-block'}>{help}</span>
    }

    return helpContent
  }

  getWrapperStyle() {
    const { style } = this.props
    let divWrapperStyle = ''
    if (!isUndefined(style) && style === 'error') {
      divWrapperStyle = 'has-error'
    }

    return divWrapperStyle
  }

  render() {
    const { id, label, formGroup } = this.props

    return (
      <Cont className={this.getWrapperStyle()} formGroup={formGroup}>
        <AInputLabel htmlFor={id}>{label}</AInputLabel>
        <Cont inline>
          {this.getHourUI()}
          {this.getMinutesUI()}
          {this.getAMPMUI()}
        </Cont>
        {this.getHelpContent()}
      </Cont>
    )
  }

  static defaultProps = {
    minTime: null,
    maxTime: null,
    use24HourFormat: false,
    value: null,
    hourLabel: 'HH',
    minuteLabel: 'MM',
    amLabel: 'AM',
    pmLabel: 'PM',
    formGroup: false,
    cmpLabelHour: 'Hour',
    cmpLabelMin: 'Minutes',
    cmpLabelAMPM: 'AM PM',
  }

  static propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    cmpRef: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    style: PropTypes.string,
    help: PropTypes.string,
    minTime: PropTypes.string,
    maxTime: PropTypes.string,
    use24HourFormat: PropTypes.bool,
    hourLabel: PropTypes.string,
    minuteLabel: PropTypes.string,
    amLabel: PropTypes.string,
    pmLabel: PropTypes.string,
    formGroup: PropTypes.bool,
    cmpLabelHour: PropTypes.string,
    cmpLabelMin: PropTypes.string,
    cmpLabelAMPM: PropTypes.string,
  }
}

export default AInputTime
